import * as yup from 'yup'

export const inventoryAddSchema = yup.object().shape({
    production_date: yup.date()
        .typeError("Harap pilih tanggal produksi")
        .required("Harap pilih tanggal produksi"),
    file_url: yup.string().required("Harap unggah file"),
})

export const inventoryMoveSchema = yup.object().shape({
    organization_target_id: yup.string().required("Harap pilih target organisasi"),
    action: yup.string().required("Harap pilih prosses pemindahan"),
    file_url: yup.string().required("Harap unggah file")
                 .test('length', 'File harus diisi', (value) => value?.length > 0),
    start_rent: yup.date().typeError("Harap pilih tanggal mulai sewa").required("Harap pilih tanggal mulai sewa"),
    end_rent: yup.date().typeError("Harap pilih tanggal akhir sewa").required("Harap pilih tanggal akhir sewa"),
})

export const inventoryReturnSchema = yup.object().shape({
    organization_source_id: yup.string().required("Harap pilih target organisasi"),
    action: yup.string().required("Harap pilih prosses pemindahan"),
    return_date: yup.date().typeError("Harap pilih tanggal kembali").required("Harap pilih tanggal kembali"),
    file_url: yup.string().required("Harap unggah file")
                 .test('length', 'File harus diisi', (value) => value?.length > 0),
})